import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-issue-seller-credit-note-register-in-detail',
  templateUrl: './issue-seller-credit-note-register-in-detail.component.html',
  styleUrls: ['./issue-seller-credit-note-register-in-detail.component.scss']
})
export class IssueSellerCreditNoteRegisterInDetailComponent implements OnInit {

  currentDate: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  issueDates1: any;
  reportType: any = 'InDetailCreditNote';
  advtCreditRegiInDetailsFormBeans: any[] = [];

  CredittadvtInDTotal: number = 0;
  CredittadvtInDTotalother: number = 0;
  CredittadvtInDTotalAmt: number = 0;
  issueName: any;
  issueDates: any;

  constructor(
    private dialogRef: MatDialogRef<IssueSellerCreditNoteRegisterInDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
    this.repName = this.data.rep_name;
    this.issueName = this.data.issue_name;
    this.issueDates = this.data.issue_date;
    this.offRepName = this.data.off_rep_name;
    this.reportType = this.data.reportType;
    this.currentDate = new Date();
    this.getCreditRegiInDetails12();


  }

  getCreditRegiInDetails12(): void {
    const req: any = {
      rep_name: this.repName,
      start_date: this.startDate,
      end_date: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_date: this.issueDates
    };

    this.service.getCreditRegiInDetails12(req).subscribe((data: any) => {
      this.advtCreditRegiInDetailsFormBeans = data || [];

      // Reset totals
      this.CredittadvtInDTotal = 0;
      this.CredittadvtInDTotalother = 0;
      this.CredittadvtInDTotalAmt = 0;

      // Calculate totals
      for (let item of this.advtCreditRegiInDetailsFormBeans) {
        this.CredittadvtInDTotal += parseFloat(item.tds_amt) || 0;
        this.CredittadvtInDTotalother += parseFloat(item.other_credit_amt) || 0;
        this.CredittadvtInDTotalAmt += parseFloat(item.credit_v_amt) || 0;
      }

      console.log("Report Data:", this.advtCreditRegiInDetailsFormBeans);
    });
  }

  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }
}
